(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-quick-bet/assets/route-play-quick-bet.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-quick-bet/assets/route-play-quick-bet.js');
"use strict";

const {
  SideNavResize
} = svs.components.tipsen.sideNavResize;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  ExternalMatchId
} = svs.components.sport.statisticsCommon;
const {
  QuickBets,
  EmptyState
} = svs.components.oddset.quickBets;
const {
  ExternalIdProviders
} = svs.components.sportinfo.common.constants;
const {
  useMediaQuery
} = svs.components.lbUtils.useMediaQuery;
const {
  STATISTIC_SIDEBAR_QUERY
} = svs.components.tipsen.constants;
const RoutePlayQuickBet = _ref => {
  let {
    branding,
    matchId,
    productId,
    sportType
  } = _ref;
  const isWideDevice = useMediaQuery(STATISTIC_SIDEBAR_QUERY);
  return React.createElement(ErrorBoundary, {
    fallback: EmptyState
  }, React.createElement(SideNavResize, null, React.createElement(ExternalMatchId, {
    branding: branding,
    FallbackComp: EmptyState,
    matchId: matchId,
    productId: productId,
    type: ExternalIdProviders.Kambi
  }, kambiEventId => React.createElement(QuickBets, {
    className: isWideDevice ? 'tipsen-side-nav-overflow' : '',
    kambiEventId: kambiEventId,
    sportType: sportType,
    stickyBottomButton: isWideDevice
  }))));
};
setGlobal('svs.components.tipsen.routePlayQuickBet.RoutePlayQuickBet', RoutePlayQuickBet);

 })(window);